module.exports = __webpack_public_path__ + "img/yangli-p@2x.3de1f95e.png";